import { createTheme } from "@mui/material/styles";

// Trust U+ brand. `primary` stays black so un-overridden MUI controls
// (checkboxes, tabs, switches, progress, text buttons) keep high-contrast black
// rather than low-contrast gold text. Solid *primary CTA* buttons are gold with
// black text — applied only to contained primary buttons, so neutral/outlined
// and error/secondary buttons are untouched.
const TU_GOLD = "#c9a552";
const TU_GOLD_HOVER = "#b68c35";

export const theme = createTheme({
  palette: {
    primary: { main: "#000000" },
    secondary: { main: "#d7b979" }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: TU_GOLD,
          color: "#000000",
          "&:hover": { backgroundColor: TU_GOLD_HOVER },
          "&.Mui-disabled": { backgroundColor: "rgba(201, 165, 82, 0.45)", color: "rgba(0,0,0,0.5)" }
        }
      }
    }
  }
});
